import { useCallback } from "react";

export function useMapEvents({ onMapClick }) {
    const handleMapClick = useCallback((e) => {
        const latLng = e?.detail?.latLng;
        if (!latLng) return;

        const lat = latLng.lat;
        const lng = latLng.lng;
        onMapClick(lat, lng);
    }, [onMapClick]);

    return {
        handlers: {
            handleMapClick,
        },
    };
}
